import React, { useEffect, useState } from 'react';
import { useRotationStore } from '../../../context/RotationContext';
import { RotationTreeEnum } from '../../../enums/rotationTreeEnum';
import { ReportLocationEnum } from '../../../enums/reportLocationEnum';
import { ReportingContextWrapper } from '../../../pages/tank-cleaning/TankCleaning.styles';
import { useVesselStore } from '../../../context/VesselContext';
import useRotation from '../../../app/useRotation';

const ReportingContextInfo: React.FC = () => {
    const [reportingLocationText, setReportingLocationText] = useState<string>('');
    const { selectedVessel } = useVesselStore();
    const { selectedNode, updatedRotation } = useRotationStore();
    const { getBerthCallFromNode } = useRotation();

    useEffect(() => {
        if (!selectedVessel) {
            setReportingLocationText('');
        }
    }, [selectedVessel]);

    useEffect(() => {
        let portText = '';

        if (selectedNode) {
            if (selectedNode.name && selectedNode.reportLocation === ReportLocationEnum.Sea) {
                portText = 'Sea';
                setReportingLocationText(portText);
            } else if (selectedNode.name && selectedNode.reportLocation === ReportLocationEnum.Port) {
                const portCall = updatedRotation?.portCallArray.find((pc) => pc.portCallId === selectedNode?.portCall?.portCallId);

                if (portCall) {
                    portText = portCall.name;
                }

                if (selectedNode.type === RotationTreeEnum.PortCall) {
                    setReportingLocationText(portText);
                } else if (selectedNode.type === RotationTreeEnum.BerthCall) {
                    if (portCall) {
                        const bc = portCall.berthCallArray.find((bc) => bc.berthCallId === selectedNode.id);
                        if (bc && bc?.name) {
                            setReportingLocationText(portText + ' <span class="separator">></span> ' + bc.name);
                        }
                    }
                } else if (selectedNode.type === RotationTreeEnum.CargoOperation) {
                    if (portCall) {
                        const bcNode = getBerthCallFromNode(selectedNode);
                        if (bcNode) {
                            const bc = portCall.berthCallArray.find((bc) => bc.berthCallId === bcNode.id);
                            if (bc && bc?.name) {
                                setReportingLocationText(
                                    portText +
                                        ' <span class="separator">></span> ' +
                                        bc.name +
                                        ' <span class="separator">></span> ' +
                                        selectedNode.name
                                );
                            }
                        }
                    }
                }
            }
        }
    }, [selectedNode]);

    return (
        <ReportingContextWrapper>
            <h3>
                Reporting at <span dangerouslySetInnerHTML={{ __html: reportingLocationText }} />
            </h3>
        </ReportingContextWrapper>
    );
};

export default ReportingContextInfo;
